import React from 'react'
import styles from './container.module.css'

export default (props) => (
  <div className={getClassName(props)}>{props.children}</div>
)

function getClassName(props) {
  return props.for === 'article' ? styles.articleContainer : styles.container;
}
